import React, { useContext, useState } from 'react'
import { FcDvdLogo} from 'react-icons/fc'

import {MdOutlineArrowBack} from 'react-icons/md'

import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/auth_context';
import { Login, Register, Service } from '../../services/api';
import pdf from '../../docs/politicas.pdf'
import { AlertContext } from '../../context/alert_context';
import Renderif from '../../components/renderif';
import Loader from '../../components/loader';
import { BsEye, BsEyeSlash } from 'react-icons/bs';

export default function RegisterView() {
  const {setUser} = useContext(AuthContext) 
  const {notify} = useContext(AlertContext)
  const [state, setState] = useState({
    email:'',
    firstname:'',
    lastname:'',
    phone:'',
    birthDate:'',
    pass:'',
    passCofirmed:'',
    loading:false, 
    error:'',
    showPassword:false
  })
  const navigate = useNavigate();

  const checkPassword = (password) => {
    var re = /(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.]).{8,}$/;
    return re.test(password);
  }

  const onRegister = async () => {

      if(
        state.email === '' ||
        state.firstname === '' ||
        state.lastname === '' ||
        state.phone === '' ||
        state.pass === '' ||
        state.passCofirmed === '' ||
        state.birthDate === ''
      
      ){
        notify({title:'Registro', message:'Todos los campos son obligatorios', type:'error'})
        return;
      }

     

      if(state.pass !== state.passCofirmed){
        notify({title:'Registro', message:'Las contraseñas no coinciden', type:'error'})
        return;
      }

      if(!checkPassword(state.passCofirmed)){
        console.log(state.passCofirmed)
        console.log(checkPassword(state.passCofirmed))
        setState({...state, error:'La contraseña debe contener 8 caracteres al menos una letra mayuscula, minuscula, numero, caracter especial, #?!@$%^&*-.#'})
        return;
      }



      setState({...state, loading:true})

      let register =  await Register({
        "cellPhone":state.phone,
        "email":state.email,
        "firstName":state.firstname,
        "lastName":state.lastname,
        "password":state.passCofirmed,
        "birthDate":state.birthDate
      })
      console.log(register)
      if(register?.status !== 200){
        notify({title:'Registro', message:'Algo salio mal, intentalo de nuevo más tarde', type:'error'})
        setState({...state, loading:false})
        return;
      }
      localStorage.setItem('token',register.data.api_token);


      let user = await Service('POST','Auth/verify_token', {'api_token':register.data.api_token})
      if(user?.status !== 200){
        notify({title:'Registro', message:'Algo salio mal, intentalo de nuevo más tarde', type:'error'})
        setState({...state, loading:false})
        return;
      }


      setUser({user:user.data})
      notify({title:`Hola! ${state.firstname}`, message:'Bienvenido de BienVivir', type:'success'})
      navigate('/client');
    

  }
  return (
    <>
     <Renderif isTrue={state.loading}>
      <Loader></Loader>
    </Renderif>
    <div className='continaer-fluid h-100 bacground-gray'>
      <div className='row p-0 m-0 bacground-gray h-100'>

        <div className='col-12 col-md-6 d-flex flex-column justify-content-center align-items-center bacground-gray'>
          <div className='bv-login-form login-form'>

            <div className='d-flex flex-column pb-3 px-4'>
              <div className='my-4'>
                <img width={120} src='assets/logo.png'></img>
              </div>
              <div className='bold f-22'> Registro</div>
              <div className='f-12 text-gray text-center px-3'></div>
            </div>


            <div className='d-inline-flex align-items-center cursor-pointer px-3
            ' onClick={()=>{
                        navigate(-1)
                    }}>
                <div className='bv-icon bv-icon--mid'><MdOutlineArrowBack size={20} color={'#0270fc'}></MdOutlineArrowBack></div>
                <div className='text-primary-bien f-14 line-0'>Regresar</div>

            </div>

            <div className='pt-2 px-4'>
              <div className='f-12 bold text-gray'>Nombre*</div>
              <input value={state.firstname} onChange={(e)=>{
                setState({...state, firstname:e.currentTarget.value})
              }} className='input--light' placeholder='Ingresa tu nombre'></input>
            </div>

            <div className='pt-2 px-4'>
              <div className='f-12 bold text-gray'>Apellidos*</div>
              <input value={state.lastname} onChange={(e)=>{
                setState({...state, lastname:e.currentTarget.value})
              }} className='input--light' placeholder='Ingresa tus apellidos'></input>
            </div>



            <div className='pt-2 px-4'>
              <div className='f-12 bold text-gray'>Email*</div>
              <input value={state.email} onChange={(e)=>{
                setState({...state, email:e.currentTarget.value})
              }} className='input--light' placeholder='Ingresa tu email'></input>
            </div>

            <div className='pt-2 px-4'>
              <div className='f-12 bold text-gray'>Celular*</div>
              <input type="tel" maxLength="10" value={state.phone} onChange={(e)=>{
                setState({...state, phone:e.currentTarget.value})
              }} className='input--light' placeholder='Ingresa tu número de celular'></input>
            </div>

            <div className='pt-2 px-4'>
              <div className='f-12 bold text-gray'>Fecha de nacimiento*</div>
              <input type="date" className='input--light' onChange={(e)=>{
                       setState({...state, birthDate:e.currentTarget.value})
              }} placeholder='Ingresa tu nombre'></input>
            </div>

            <div className='pt-2 d-flex align-items-end px-4'>

              <div className='col'>
                <div className='f-12 bold text-gray'>Contraseña*</div>
                <input type={`${state.showPassword ? 'text': 'password'}`} className='input--light' value={state.pass} onChange={(e)=>{
                  console.log(checkPassword(e.currentTarget.value))
                        setState({...state, pass:e.currentTarget.value})
                }} placeholder='Ingresa tu contraseña'></input>
              </div>

              <Renderif isTrue={state.showPassword === true}>
                <div className='bv-icon bv-icon--mid mx-2 mb-2 cursor-pointer' onClick={()=>{
                
                  setState({...state, showPassword:false})

                }}>
                  <BsEye size={30}></BsEye>
                </div>
              </Renderif>

              <Renderif isTrue={state.showPassword === false}>
                <div className='bv-icon bv-icon--mid mx-2 mb-2 cursor-pointer' onClick={()=>{
                       
                  setState({...state, showPassword:true})

                }}>
                  <BsEyeSlash size={30}></BsEyeSlash>
                </div>
              </Renderif>
              

            </div>

            <div className='pt-2 d-flex align-items-end px-4'>

              <div className='col'>
                <div className='f-12 bold text-gray'>Confirmar Contraseña*</div>
                <input type={`${state.showPassword ? 'text': 'password'}`} className='input--light' value={state.passCofirmed} onChange={(e)=>{
                        setState({...state, passCofirmed:e.currentTarget.value})
                }} placeholder='Confirma tu contraseña'></input>
              </div>


              <Renderif isTrue={state.showPassword === true}>
                <div className='bv-icon bv-icon--mid mx-2 mb-2 cursor-pointer' onClick={()=>{
                
                  setState({...state, showPassword:false})

                }}>
                  <BsEye size={30}></BsEye>
                </div>
              </Renderif>

              <Renderif isTrue={state.showPassword === false}>
                <div className='bv-icon bv-icon--mid mx-2 mb-2 cursor-pointer' onClick={()=>{
                       
                  setState({...state, showPassword:true})

                }}>
                  <BsEyeSlash size={30}></BsEyeSlash>
                </div>
              </Renderif>
              
            </div>
            <div className='f-12 text-red'>{state.error}</div>

          

            <div className='py-3 px-4'>
              <div className='bv-cta bv-cta--primary-bien w-100' onClick={()=>{onRegister()}}>
                <div className='text-center w-100'>Continuar</div>
              </div>

              {/* <a target='_blank'  href={'/politicas'}><div className='f-12 text-primary text-decoration-underline cursor-pointer text-center mt-3'>Aviso de privacidad</div></a> */}

              <a target='_blank'  href='https://bienvivir-static.s3.us-east-2.amazonaws.com/politicas.pdf'><div className='f-12 text-primary-bien
               text-decoration-underline cursor-pointer text-center mt-3'>Aviso de privacidad</div></a>
         
            </div>

          </div>

        </div>

        <div className='col d-md-block'>
              <div className='back-filter-login bacground-gray'>
                <img className='' src='assets/swinging_home.png'></img>
              </div>
          </div>

      </div>
    </div>
    </>
  )
}
